module.exports = __webpack_public_path__ + "static/store_google.475d330e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/store_google.svg
// module id = 1164
// module chunks = 35783957827783